export const rotateByYAxis = (sprite) => {
  sprite.scale.x = -sprite.scale.x;
  sprite.x += sprite.width;
};
